import { render, staticRenderFns } from "./circular.vue?vue&type=template&id=49613e3c&scoped=true&"
import script from "./circular.vue?vue&type=script&lang=ts&"
export * from "./circular.vue?vue&type=script&lang=ts&"
import style0 from "./circular.vue?vue&type=style&index=0&id=49613e3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49613e3c",
  null
  
)

export default component.exports